import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Languages, Layers } from "lucide-react";

const UPGRADES = [
  {
    icon: BadgeCheck,
    title: "Guaranteed UAE Placements",
    desc: "Named titles like Khaleej Times and Gulf News from $600. Published or refunded.",
    to: "/uae",
  },
  {
    icon: Languages,
    title: "Arabic Newswire",
    desc: "Arabic-first distribution across the wider Arab world.",
    to: "/services/newswire-distribution",
  },
  {
    icon: Layers,
    title: "Curated Gulf Packages",
    desc: "Wire plus placements bundles priced below buying separately.",
    to: "/packages",
  },
];

export default function GulfNewswireUpgrade() {
  return (
    <section className="py-12 lg:py-16 bg-canvas">
      <Container>
        <SectionHeading tag="UPGRADE" title="Need more than the Gulf wire?" />

        <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
          {UPGRADES.map((u) => (
            <div
              key={u.title}
              className="group bg-white border border-border rounded-xl p-7 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 mb-5">
                <u.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-lg font-bold text-bone mb-2">{u.title}</h3>
              <p className="text-sm text-steel leading-relaxed mb-5">{u.desc}</p>
              <Link
                to={u.to}
                className="inline-flex items-center text-sm font-medium text-cobalt hover:text-cobalt/80 transition-colors mt-auto"
              >
                Learn more <ArrowRight className="ml-1.5 w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}